import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { APP_PATH } from '@app/app.constants';

import {
    LoginFormComponent,
    RegistrationFormComponent,
    HomeComponent,
    UnauthorizedComponent,
    UnsubscribeComponent
} from '@app/core/components';

const appRoutes: Routes = [
    { path: '', component: UnauthorizedComponent },
    { path: 'unsubscribe_email/:user_id', component: UnsubscribeComponent },
    {
        path: APP_PATH.home,
        component: HomeComponent,
        children: [
            { path: APP_PATH.profile.main, loadChildren: '@profile/profile.module#ProfileModule' },
            { path: APP_PATH.teacher.main, loadChildren: '@teacher/teacher.module#TeacherModule' },
            { path: APP_PATH.student.main, loadChildren: '@student/student.module#StudentModule' },
            { path: APP_PATH.results.main, loadChildren: '@results/results.module#ResultsModule' },
            { path: APP_PATH.reports.main, loadChildren: '@reports/reports.module#ReportsModule' }
        ]
    },
    { path: APP_PATH.login, component: LoginFormComponent },
    { path: APP_PATH.registration, component: RegistrationFormComponent },
    { path: '**', redirectTo: APP_PATH.home }
];

@NgModule({
    imports: [
        RouterModule.forRoot(
            appRoutes,
            { enableTracing: false } // <-- debugging purposes only
        )
    ],
    declarations: [],
    exports: [RouterModule]
})
export class AppRoutingModule {}
